module.exports = __webpack_public_path__ + "static/img/traffic_pressure.5bc982d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/traffic_pressure.png
// module id = vXE8
// module chunks = 8